import { Box, Heading } from "@chakra-ui/react"
import styles from './mystyle.module.css';
import logo from './zigridLogo.jpg'


const Banner = ({...props}) => {
    return <Box  {...props}  >
	        	<Heading  textAlign="center"
	            		py="2%"
	            		as="h2" 
	            		size="4xl"
	            		color="rgba(0,0,0,0.7)"
			            userSelect="none"
			            fontWeight="700"
			            letterSpacing="0.099em"   >
	
					<center >
			   			<img className={styles.responsive} src={logo}  alt="zigrid logo"  />
			 		</center>
	        	</Heading>
    		</Box>
}
export default Banner